export * from '@primeuix/themes/lara/editor';
export { default } from '@primeuix/themes/lara/editor';
